//useStorage.js
import { storage } from "@/firebase/init";
import { db } from "@/firebase/init";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import Compressor from 'compressorjs';
import {usersCollection, profilePicturespath} from './useGlobalVariables'


/**
 * Uploads a compressed and resized profile picture, replaces the old one, and updates Firestore
 * @param {string} uid - User ID
 * @param {File} file - The image file to upload
 */
export const uploadProfilePicture = async (uid, file) => {
    try {
      if (!uid || !file) throw new Error("Invalid user ID or file.");
  
      // Compress and resize the image before uploading
      const resizedFile = await new Promise((resolve, reject) => {
        new Compressor(file, {
          maxWidth: 800,      // Max width of the image
          maxHeight: 800,     // Max height of the image
          quality: 0.8,       // Image quality (0 to 1)
          success: resolve,
          error: reject,
        });
      });
  
      // Define the fixed file name for every user (you can change the file extension if needed)
      const imageRef = ref(storage, `${profilePicturespath}/${uid}/profile.png`);
  
      // Upload resized and compressed file to Firebase Storage (overwrites existing one)
      await uploadBytes(imageRef, resizedFile);
  
      // Get the new download URL
      const downloadURL = await getDownloadURL(imageRef);
  
      // Update Firestore with the new profile picture URL
      await updateDoc(doc(db, usersCollection, uid), { profilePicture: downloadURL });
  
      return { success: true, message: "Profile picture updated successfully", url: downloadURL };
    } catch (error) {
      console.error("Error uploading profile picture:", error);
      return { success: false, message: error.message };
    }
  };



  
/**
 * Deletes a user's profile picture from Storage and Firestore
 * @param {string} uid - User ID
 */
export const deleteProfilePicture = async (uid) => {
  try {
    if (!uid) throw new Error("Invalid user ID.");

    // Reference to the user's profile picture
    const imageRef = ref(storage, `${profilePicturespath}/${uid}/profile.png`);

    // Delete image from Firebase Storage
    await deleteObject(imageRef);

    // Remove profilePicture field from Firestore
    await updateDoc(doc(db, usersCollection, uid), { profilePicture: null });

    return { success: true, message: "Profile picture deleted successfully" };
  } catch (error) {
    console.error("Error deleting profile picture:", error);
    return { success: false, message: error.message };
  }
};
